import xss from 'xss';

export const vowels = ['a', 'e', 'i', 'o', 'u'];
export const vowelsAndY = ['a', 'e', 'i', 'o', 'u', 'y'];

export const aOrAn = (text, capitalise = false) => {
	const first = text.slice(0, 1).toLowerCase();
	if (capitalise) {
		return vowels.some(l => l === first) ? 'An' : 'A';
	} else {
		return vowels.some(l => l === first) ? 'an' : 'a';
	}
};

export const fileSizes = {
	kb: 1024,
	mb: 1024 * 1024,
	gb: 1024 * 1024 * 1024,
	tb: 1024 * 1024 * 1024 * 1024,
};

export const bytesToSize = bytes => {
	if (bytes < fileSizes.kb) return `${bytes} bytes`;
	if (bytes < fileSizes.mb) return `${Math.floor(bytes / fileSizes.kb)}KB`;
	if (bytes < fileSizes.gb) return `${Math.floor(bytes / fileSizes.mb)}MB`;
	if (bytes < fileSizes.tb) return `${Math.floor(bytes / fileSizes.gb)}GB`;
	return `${Math.floor(bytes / fileSizes.tb)}TB`;
};

export const displayMinutes = mins => {
	let minuteText = systemText('General/Time/Minute');
	minuteText = minuteText !== 'General/Time/Minute' ? minuteText : 'minute';
	let minuteTextPlural = systemText('General/Time/Minutes');
	minuteTextPlural = minuteTextPlural !== 'General/Time/Minutes' ? minuteTextPlural : 'minutes';
	let hourText = systemText('General/Time/Hour');
	hourText = hourText !== 'General/Time/Hour' ? hourText : 'hour';
	let hourTextPlural = systemText('General/Time/Hours');
	hourTextPlural = hourTextPlural !== 'General/Time/Hours' ? hourTextPlural : 'hours';

	const hours = Math.floor(mins / 60);
	let minutes = mins % 60;
	if (minutes % 1 !== 0) minutes = Math.round(minutes, 1);
	const hoursText = hours > 0 ? `${hours} ${hours === 1 ? hourText : hourTextPlural}` : '';
	const minutesText = minutes > 0 ? `${minutes} ${minutes === 1 ? minuteText : minuteTextPlural}` : '';
	return `${hoursText}${hoursText && minutesText ? ' ' : ''}${minutesText}`;
};

export const displaySeconds = secs => {
	secs = typeof secs === 'string' ? parseInt(secs, 10) : secs;

	if (!secs) {
		return '00:00';
	}

	const seconds = (secs || 0).toFixed(0);
	const mins = Math.floor(seconds / 60);
	const minsText = mins > 99 ? mins : mins > 0 ? `0${mins}`.slice(-2) : '00';
	const secsText = seconds % 60 > 0 ? `0${seconds % 60}`.slice(-2) : '00';
	return `${minsText}:${secsText}`;
};

export const possession = string => {
	return `${string}'s`;
};

export const pluralise = (string, number) => {
	return number === 1 ? string : `${string}s`;
};

export const colourByIndex = idx => {
	const colours = [
		'#ff8c00',
		'#00bcf2',
		'#68217a',
		'#e81123',
		'#00b294',
		'#ec008c',
		'#009e49',
		'#bad80a',
		'#00188f',
		'#fff100',
	];
	return colours[idx % colours.length];
};

export const regExs = {
	// eslint-disable-next-line
	EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	URL: /\b(https?|ftp|file):\/\/[\-A-Za-z0-9+&@#\/%?=~_|!:,.;]*[\-A-Za-z0-9+&@#\/%=~_|]/,
	PASSWORD: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(.*){8,}$/,
};

export const matchRegEx = (regEx, value, caseInsensitive = true) => {
	let patt = new RegExp(regEx);
	value = caseInsensitive ? value.toLowerCase() : value;
	return patt.test(value);
};

export const formatTextToHtml = text => (text ? text.replace('\n', '<br />') : '');

export const ensureProtcol = url => (url && url.indexOf('http') !== 0 ? `//${url}` : url);

export const containsExt = (file, extensions) => {
	let result = false;
	let lowerFile = file.toLowerCase();
	extensions.forEach(e => {
		result = result || lowerFile.indexOf(e.toLowerCase()) === lowerFile.length - e.length;
	});
	return result;
};

export const capitalise = s => s[0].toUpperCase() + s.substring(1);

export const arrayToString = (array, separator, andOr) => {
	if (!array || array.length === 0) return '';
	if (array.length === 1) return array[0];
	const start = array.slice(0, array.length - 1);
	const last = array[array.length - 1];

	if (start.length === 1) {
		return `${start[0]} ${andOr} ${last}`;
	}

	return `${start.join(`${separator} `)} ${andOr} ${last}`;
};

export const arraysEqual = (arr1, arr2) =>
	JSON.stringify(arr1 ? arr1.sort() : []) === JSON.stringify(arr2 ? arr2.sort() : []);

export const formatMetric = (format, value, symbol) => {
	switch (format) {
		case 'M':
			return value || value === 0 ? `${symbol ? symbol : '£'}${parseInt(value, 10).toLocaleString()}` : '-';
		case 'R':
			return value || value === 0 ? `${parseFloat(value).toFixed(1).toLocaleString()}` : '-';
		case 'S':
			return value || value === 0 ? displaySeconds(value) : '-';
		case 'P':
			return value || value === 0 ? `${(value * 100).toFixed(1)}%` : '-';
		case 'D':
			return value || value === 0 ? value.toFixed(1) : '-';
		default:
			return value || value === 0 ? parseInt(value, 10).toLocaleString() : '-';
	}
};

export const isLaterVersion = (v1, v2) => {
	if (typeof v1 !== 'string') v1 = '0.0.0';
	if (typeof v2 !== 'string') v2 = '0.0.0';
	v1 = v1.split('.');
	v2 = v2.split('.');
	const k = Math.min(v1.length, v2.length);
	for (let i = 0; i < k; ++i) {
		v1[i] = parseInt(v1[i], 10);
		v2[i] = parseInt(v2[i], 10);
		if (v1[i] > v2[i]) return true;
		if (v1[i] < v2[i]) return false;
	}

	return v1.length <= v2.length ? false : true;
};

export const getOrdinalSuffix = num => {
	const number = num.toString();
	if (number.endsWith('11')) return 'th';
	if (number.endsWith('12')) return 'th';
	if (number.endsWith('13')) return 'th';
	if (number.endsWith('1')) return 'st';
	if (number.endsWith('2')) return 'nd';
	if (number.endsWith('3')) return 'rd';
	return 'th';
};

export const systemText = (textPath, param1, param2, param3, param4, param5) => {
	const transRef = document.TRANSLATIONS?.find(t => t.name.toLowerCase() === textPath.toLowerCase());
	let trans = transRef ? transRef.value : '';

	const valid = p => p !== undefined && p !== null;

	if (trans) {
		if (valid(param1)) trans = trans.replaceAll('{0}', param1);
		if (valid(param2)) trans = trans.replaceAll('{1}', param2);
		if (valid(param3)) trans = trans.replaceAll('{2}', param3);
		if (valid(param4)) trans = trans.replaceAll('{3}', param4);
		if (valid(param5)) trans = trans.replaceAll('{4}', param5);
	}

	return trans ? trans : textPath;
};

export const cleanXSS = value => {
	return xss(value);
};
